import { changeFontSize } from '../dataServices/changeFontSize';

/**
 * 设置系统字号偏好
 * @param {string}    fontSize     small 等
 */
export const setFontSize = (fontSize: string) => {
    return changeFontSize(fontSize);
};
